<div class="transparent-card-container">
  <div class="transparent-card">
    <div class="top-search-bar">
      <img
        src="/assets/img/static-pages/medigi/v2-images/standalone-icons/magnify-glass.svg"
        alt="Search"
      />
    </div>
    <div class="transparent-card-body">
      <table>
        <tr class="body-row">
          <td class="copy">
            <p class="mb-0">Full-dated meds</p>
          </td>
          <td class="image">
            <img src="/assets/img/logos/medigi-logo-blue.svg" alt="medigi" />
          </td>
        </tr>
        <tr class="body-row">
          <td class="copy">
            <p class="mb-0">Short-dated deals</p>
          </td>
          <td class="image">
            <img src="/assets/img/logos/ms_teal_logo.svg" alt="MedShorts" />
          </td>
        </tr>
        <tr class="body-row">
          <td class="copy">
            <p class="mb-0">Compounded drugs</p>
          </td>
          <td class="image">
            <img src="/assets/img/logos/503B_Color.svg" alt="503b" />
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
